// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_6op","cls2":"LoswpTabsHero-cls2_M5P LoswpTabsHero-cls1_6op"};